module.exports = __webpack_public_path__ + "img/2.fb6d5810.jpeg";